import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Node } from "prosemirror-model";
import { Decoration, DecorationSet } from "prosemirror-view";

function findAllSubstrs(str: string, substr: string) {
  const result: { from: number; to: number }[] = [];
  let i = 0;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const pos = str.toLowerCase().indexOf(substr.toLowerCase(), i);
    if (pos === -1) break;
    result.push({
      from: pos,
      to: pos + substr.length,
    });
    i = pos + 1;
  }

  return result;
}

function lint(doc: Node, stopWordsList: { word: string; caption: string }[]) {
  const result: { msg: string; from: number; to: number }[] = [];

  function addRecord(msg: string, from: number, to: number) {
    result.push({ msg, from, to });
  }

  // For each node in the document
  doc.descendants((node, pos) => {
    const nodeText = node.text;
    if (node.isText && nodeText) {
      // Scan text nodes for suspicious patterns

      stopWordsList.forEach(({ word, caption }) => {
        findAllSubstrs(nodeText, word).forEach(({ from, to }) => {
          addRecord(caption, pos + from, pos + to);
        });
      });
    }
  });

  return result;
}

function stopWordsDecorator(
  doc: Node,
  stopWordsList: { word: string; caption: string }[]
) {
  const decorations: Decoration[] = [];

  lint(doc, stopWordsList).forEach((prob) => {
    decorations.push(
      Decoration.inline(prob.from, prob.to, {
        class: "stop-word-marker",
        "data-title": prob.msg,
      })
    );
  });

  return DecorationSet.create(doc, decorations);
}

const StowWords = Extension.create<{
  stopWordsList?: { word: string; caption: string }[];
}>({
  name: "stopw-words",

  addProseMirrorPlugins() {
    const { stopWordsList } = this.options;

    return stopWordsList
      ? [
          new Plugin({
            key: new PluginKey("stopw-words"),
            state: {
              init(_, { doc }) {
                return stopWordsDecorator(doc, stopWordsList);
              },
              apply(tr, old) {
                return tr.docChanged
                  ? stopWordsDecorator(tr.doc, stopWordsList)
                  : old;
              },
            },
            props: {
              decorations(state) {
                return this.getState(state);
              },
            },
          }),
        ]
      : [];
  },
});

export default StowWords;
